import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

export const HeroTitle: React.FC<Props> = ({ className }) => (
	<>
		<Text data-testid="homepage-hero-heading" variant="display" as="h1" className={className}>
			<TranslateHtml value="corgi.homepage.hero_sunrise.title" />
			<span className="text-typography-brand dark:text-icon-brand">.</span>
		</Text>
		<Text data-qa="homepage-hero-subheading" variant="body" as="h2" className="mt-2 mb-8 text-center lg:mb-10">
			<Translate value="corgi.homepage.hero_section.subheading" />
		</Text>
	</>
);

type Props = Readonly<{
	className?: string;
}>;
